import { FieldFilter } from '../../../stores/types';

export const getNormalizedFilters = (filters?: Record<string, FieldFilter[]>): Record<string, string[]>  => {
  if (filters) {
    const filtersFields = Object.keys(filters);
    let normalizedFilters = {};
    filtersFields.forEach((filtersField) => {
      const filterValue = filters[filtersField]?.map((filter) => filter.filterValue);
      normalizedFilters = {
        ...normalizedFilters,
        [filtersField]: filterValue,
      };
    });

    return normalizedFilters;
  }
  return {};
};